import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
import React, { useCallback, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
const EmployeeComments = _ref => {
  let {
    selectedProject
  } = _ref;
  const [employeeComments, setEmployeeComments] = useState('');
  const saveEmployeeComment = useErrorHandling(useCallback(async event => {
    await generalRouteSubRouteService.update(selectedProject.claim_group_id, 'claim_groups', 'claim_project_reports', selectedProject.id, {
      ...selectedProject,
      employee_comments: event.target.value
    });
  }, [selectedProject]));
  const getEmployeeComment = useErrorHandling(useCallback(async () => {
    const response = await generalRouteSubRouteService.get(selectedProject.claim_group_id, 'claim_groups', 'claim_project_reports', selectedProject.id);
    setEmployeeComments(response.employee_comments);
  }, [selectedProject]));
  useEffect(() => {
    getEmployeeComment();
  }, [getEmployeeComment]);
  return /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    rows: 3,
    placeholder: "Enter text",
    value: employeeComments,
    onChange: e => setEmployeeComments(e.target.value),
    onBlur: saveEmployeeComment
  });
};
export default EmployeeComments;